import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const TERMS_OF_SERVICE = `[버전 1.0 | 시행일: 2026년 3월 1일]

제1조 (목적)
본 약관은 HubCore 서비스(이하 "서비스")의 이용과 관련하여 서비스를 제공하는 자(이하 "회사")와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조 (용어의 정의)
1. "서비스"란 회사가 제공하는 기업용 업무 관리 플랫폼(SaaS)을 말합니다.
2. "이용자"란 본 약관에 따라 서비스를 이용하는 자를 말합니다.
3. "회원"이란 서비스에 가입하여 이용자 자격을 부여받은 자를 말합니다.
4. "기업회원"이란 기업 단위로 서비스에 가입하여 소속 임직원에게 서비스를 제공하는 법인 또는 개인사업자를 말합니다.
5. "관리자"란 기업회원 내에서 서비스 운영 및 관리 권한을 부여받은 이용자를 말합니다.

제3조 (약관의 효력 및 변경)
1. 본 약관은 서비스를 이용하고자 하는 모든 이용자에게 적용됩니다.
2. 회사는 관련 법령의 변경, 서비스 정책 변경 등 합리적인 사유가 발생할 경우 약관을 변경할 수 있으며, 변경 시 최소 7일 전 서비스 내 공지 또는 이메일을 통해 사전 고지합니다.
3. 변경된 약관에 동의하지 않는 회원은 서비스 이용을 중단하고 탈퇴를 요청할 수 있습니다.

제4조 (서비스의 제공)
1. 회사는 다음과 같은 서비스를 제공합니다.
   - 인사/조직 관리: 직원 정보 관리, 부서·직급 관리, 온보딩
   - 근태 관리: 출퇴근 기록, 연차·휴가 관리, 근무 스케줄
   - 전자결재: 결재 문서 작성·승인·반려, 결재선 관리
   - 메시징 및 협업: 1:1 및 그룹 채팅, 파일 공유
   - 프로젝트 관리: 프로젝트 투입 인력 관리, 공수 관리
   - 파일 관리: 문서 업로드·다운로드·공유, 파일 폴더 관리
   - 경비 및 법인카드 관리: 경비 청구, 법인카드 사용 내역
   - 급여 관리: 급여명세서 조회
   - 출장 관리: 출장 신청·결과 보고
   - 일정 관리: 개인·팀 일정, 회의 관리
   - 알림: 서비스 내 알림, 이메일, 푸시 알림
   - 기타 회사가 추가로 제공하는 부가 서비스
2. 서비스는 연중무휴 24시간 제공을 원칙으로 하나, 정기 점검 등의 사유로 일시 중단될 수 있습니다.

제5조 (회원가입 및 승인)
1. 이용자는 본 약관에 동의하고 회원가입 신청을 한 후, 관리자의 승인을 받아 서비스를 이용할 수 있습니다.
2. 기업회원 가입의 경우, 회사의 승인 후 서비스를 이용할 수 있습니다.
3. 회사는 다음 각 호에 해당하는 경우 가입을 거절할 수 있습니다.
   - 타인의 정보를 도용한 경우
   - 허위 정보를 기재한 경우
   - 기타 서비스 운영에 지장을 초래할 우려가 있는 경우

제6조 (회원의 의무)
1. 회원은 관계 법령 및 본 약관의 규정을 준수하여야 합니다.
2. 회원은 자신의 계정 정보(이메일, 비밀번호)를 안전하게 관리하여야 하며, 이를 제3자에게 양도하거나 대여할 수 없습니다.
3. 회원은 타인의 개인정보를 수집·저장·유포하여서는 안 됩니다.
4. 회원은 서비스를 통해 취득한 업무상 비밀 및 기업 정보를 외부에 유출하여서는 안 됩니다.
5. 회원은 서비스를 본래 목적에 맞게 사용하여야 하며, 부정한 목적으로 사용하여서는 안 됩니다.

제7조 (회사의 의무)
1. 회사는 안정적인 서비스 제공을 위해 최선을 다합니다.
2. 회사는 회원의 개인정보를 보호하며, 개인정보처리방침에 따라 적법하게 처리합니다.
3. 회사는 서비스 장애 발생 시 신속하게 복구하도록 노력합니다.

제8조 (서비스 이용의 제한 및 해지)
1. 회사는 회원이 본 약관을 위반한 경우 서비스 이용을 제한하거나 계정을 해지할 수 있습니다.
2. 회원은 언제든지 서비스 탈퇴를 요청할 수 있으며, 회사는 관련 법령에 따라 처리합니다.

제9조 (면책 조항)
1. 회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중단 등 불가항력으로 인한 서비스 중단에 대해 책임을 지지 않습니다.
2. 회사는 회원의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.
3. 회사는 회원이 서비스를 통해 게시하거나 전송한 정보의 정확성, 신뢰도에 대해 책임을 지지 않습니다.

제10조 (분쟁 해결)
1. 본 약관에 관한 분쟁은 대한민국 법률에 따르며, 관할 법원은 회사 소재지를 관할하는 법원으로 합니다.

부칙
본 약관은 2026년 3월 1일부터 시행합니다.`;

const PRIVACY_POLICY = `[버전 1.0 | 시행일: 2026년 3월 1일]

개인정보 수집 및 이용 동의

HubCore 서비스(이하 "서비스")는 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 수집 및 이용에 대해 안내드립니다.

1. 수집하는 개인정보 항목

 가. 회원가입 시 수집 (필수)
   - 이름, 이메일 주소, 비밀번호, 연락처

 나. 서비스 이용 과정에서 수집 (필수)
   - 인사 정보: 부서, 직급, 직책, 사번, 입사일, 재직 상태
   - 근태 정보: 출퇴근 시간, 출퇴근 시 IP 주소
   - 휴가 정보: 연차 사용 내역, 휴가 신청·승인 기록
   - 결재 정보: 결재 문서 작성·승인·반려 기록
   - 메시지: 채팅 내용, 첨부 파일
   - 프로젝트: 투입 내역, 기여도, 업무 내용
   - 경비: 경비 청구 내역, 영수증
   - 급여: 급여명세서 조회 기록
   - 알림: 알림 수신 설정, 푸시 토큰(FCM)
   - 접속 기록: 로그인 시간, 접속 IP, 브라우저·기기 정보

 다. 서비스 이용 과정에서 수집 (선택)
   - 프로필 사진, 영문명, 개인 이메일, 주소
   - 생년월일, 이전 경력(개월수)
   - 비상연락처(이름, 전화번호, 관계)
   - 인사 서류(이력서, 자격증, 건강검진 결과 등)

2. 개인정보의 수집 및 이용 목적

 가. 회원 관리
   - 회원가입 의사 확인, 본인 인증, 회원 식별
   - 가입 승인 처리, 부정 이용 방지

 나. 서비스 제공
   - 인사·조직 관리, 근태·휴가 관리
   - 전자결재 및 문서 관리
   - 메시징 및 실시간 협업
   - 프로젝트 투입 관리 및 성과 관리
   - 경비 청구·법인카드·출장 관리
   - 급여명세서 조회
   - 일정 관리
   - 파일 업로드·다운로드·공유

 다. 알림 서비스
   - 서비스 내 알림, 이메일 알림
   - 모바일 푸시 알림(Firebase Cloud Messaging)
   - 웹 푸시 알림

 라. 보안 및 감사
   - 부정 접근 방지 및 보안 관리
   - 접속 기록 및 활동 로그 관리(감사 추적)
   - 기기 신뢰 관리(Trusted Device)

3. 개인정보의 보유 및 이용 기간

 가. 회원 탈퇴 시까지 보유하며, 탈퇴 후 지체 없이 파기합니다.
     단, 관련 법령에 의한 보존 의무가 있는 경우 해당 기간까지 보존합니다.

 나. 법령에 따른 보존 기간
   - 근로기준법: 근로계약, 임금대장 등 근로 관련 기록 3년
   - 국세기본법: 세무 관련 기록 5년
   - 통신비밀보호법: 접속 로그 기록 3개월
   - 전자상거래법: 계약 또는 청약철회에 관한 기록 5년

4. 개인정보의 제3자 제공
   - 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다.
   - 다만, 이용자의 동의가 있거나 법령에 의한 경우는 예외로 합니다.

5. 개인정보 처리 위탁
   서비스 제공을 위해 다음과 같이 개인정보 처리를 위탁합니다.
   - 클라우드 인프라: 서버 운영 및 데이터 저장
   - 파일 저장소: 문서·이미지 등 파일 저장 및 관리
   - 이메일 발송: 알림 이메일 발송
   - 푸시 알림: Firebase Cloud Messaging을 통한 모바일 알림 발송

6. 개인정보의 파기 절차 및 방법
   - 파기 절차: 보유 기간이 경과하거나 처리 목적이 달성된 개인정보는 지체 없이 파기합니다.
   - 파기 방법: 전자적 파일은 복구할 수 없는 방법으로 영구 삭제하며, 종이 문서는 분쇄하거나 소각합니다.

7. 이용자의 권리와 행사 방법
   - 이용자는 언제든지 자신의 개인정보에 대해 열람, 정정, 삭제, 처리 정지를 요청할 수 있습니다.
   - 요청은 서비스 내 프로필 설정 또는 관리자에게 문의하여 처리할 수 있습니다.

8. 개인정보의 안전성 확보 조치
   - 비밀번호 암호화 저장 (bcrypt)
   - 데이터 전송 시 SSL/TLS 암호화
   - 접근 권한 관리 및 역할 기반 접근 제어(RBAC)
   - 접속 기록 보관 및 위·변조 방지
   - 파일 무결성 검증 (SHA256 해시)

9. 동의 거부권 및 거부 시 불이익
   - 이용자는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다.
   - 다만, 필수 항목에 대한 동의를 거부할 경우 회원가입 및 서비스 이용이 제한됩니다.

본 동의서는 2026년 3월 1일부터 시행합니다.`;

interface ConsentCheckboxesProps {
  termsAgreed: boolean;
  privacyAgreed: boolean;
  onTermsChange: (checked: boolean) => void;
  onPrivacyChange: (checked: boolean) => void;
  termsContent?: string;
  privacyContent?: string;
  errors?: {
    terms?: string;
    privacy?: string;
  };
}

export default function ConsentCheckboxes({
  termsAgreed,
  privacyAgreed,
  onTermsChange,
  onPrivacyChange,
  termsContent,
  privacyContent,
  errors,
}: ConsentCheckboxesProps) {
  const [viewingContent, setViewingContent] = useState<"terms" | "privacy" | null>(null);

  const allAgreed = termsAgreed && privacyAgreed;

  const handleAllAgree = (checked: boolean) => {
    onTermsChange(checked);
    onPrivacyChange(checked);
  };

  return (
    <div className="space-y-3 rounded-lg border p-4">
      {/* 전체 동의 */}
      <div className="flex items-center space-x-2 pb-3 border-b">
        <Checkbox
          id="agree-all"
          checked={allAgreed}
          onCheckedChange={(checked) => handleAllAgree(checked === true)}
        />
        <label
          htmlFor="agree-all"
          className="text-sm font-semibold cursor-pointer select-none"
        >
          전체 동의
        </label>
      </div>

      {/* 이용약관 */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="agree-terms"
            checked={termsAgreed}
            onCheckedChange={(checked) => onTermsChange(checked === true)}
          />
          <label
            htmlFor="agree-terms"
            className="text-sm cursor-pointer select-none"
          >
            <span className="text-destructive mr-1">[필수]</span>
            이용약관 동의
          </label>
        </div>
        <button
          type="button"
          className="text-xs text-muted-foreground hover:text-foreground underline"
          onClick={() => setViewingContent("terms")}
        >
          내용 보기
        </button>
      </div>
      {errors?.terms && (
        <p className="text-sm text-destructive ml-6">{errors.terms}</p>
      )}

      {/* 개인정보수집동의 */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="agree-privacy"
            checked={privacyAgreed}
            onCheckedChange={(checked) => onPrivacyChange(checked === true)}
          />
          <label
            htmlFor="agree-privacy"
            className="text-sm cursor-pointer select-none"
          >
            <span className="text-destructive mr-1">[필수]</span>
            개인정보 수집 및 이용 동의
          </label>
        </div>
        <button
          type="button"
          className="text-xs text-muted-foreground hover:text-foreground underline"
          onClick={() => setViewingContent("privacy")}
        >
          내용 보기
        </button>
      </div>
      {errors?.privacy && (
        <p className="text-sm text-destructive ml-6">{errors.privacy}</p>
      )}

      {/* 약관 내용 다이얼로그 */}
      <Dialog open={viewingContent !== null} onOpenChange={() => setViewingContent(null)}>
        <DialogContent className="sm:w-[calc(100%-2rem)] max-w- mx-auto[600px] max-h-[80vh]">
          <DialogHeader>
            <DialogTitle>
              {viewingContent === "terms" ? "이용약관" : "개인정보 수집 및 이용 동의"}
            </DialogTitle>
          </DialogHeader>
          <div className="overflow-y-auto max-h-[60vh] whitespace-pre-wrap text-sm text-muted-foreground leading-relaxed p-4 border rounded-lg bg-muted/30">
            {viewingContent === "terms"
              ? (termsContent || TERMS_OF_SERVICE)
              : (privacyContent || PRIVACY_POLICY)}
          </div>
          <div className="flex justify-end">
            <Button variant="outline" onClick={() => setViewingContent(null)}>
              닫기
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
